import Input from "../campaign/wizard/Input";

const LIMIT_OPTIONS = [10, 15, 50];

const STATUS_OPTIONS = [
    { value: "", label: "All statuses" },
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" },
    { value: "failed", label: "Failed" },
    { value: "canceled", label: "Canceled" },
];

export default function PaymentListFilters({
    limit,
    onLimitChange,
    startDate,
    onStartDateChange,
    endDate,
    onEndDateChange,
    status,
    onStatusChange,
    planId,
    onPlanIdChange,
    planOptions = [],
}) {
    return (
        <div className="mb-4 rounded-xl border border-slate-200 bg-white p-3">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between lg:gap-4">
                <Input
                    as="select"
                    size="sm"
                    label="Show"
                    labelIcon="list-ul"
                    value={limit}
                    onChange={(e) => onLimitChange(Number(e.target.value))}
                    options={LIMIT_OPTIONS.map((value) => ({
                        value,
                        label: `${value}`,
                    }))}
                    wrapperClassName="w-full lg:w-[3rem] lg:shrink-0"
                />

                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
                    <Input
                        as="select"
                        size="sm"
                        label="Status"
                        labelIcon="flag"
                        value={status}
                        onChange={(e) => onStatusChange(e.target.value)}
                        options={STATUS_OPTIONS}
                        wrapperClassName="w-full"
                    />
                    <Input
                        as="select"
                        size="sm"
                        label="Plan"
                        labelIcon="credit-card"
                        value={planId}
                        onChange={(e) => onPlanIdChange(e.target.value)}
                        options={[
                            { value: "", label: "All plans" },
                            ...planOptions.map((plan) => ({
                                value: plan.plan_id,
                                label: plan.name,
                            })),
                        ]}
                        wrapperClassName="w-full"
                    />
                    <Input
                        type="date"
                        size="sm"
                        label="From"
                        labelIcon="calendar-event"
                        value={startDate}
                        onChange={(e) => onStartDateChange(e.target.value)}
                        wrapperClassName="w-full"
                    />
                    <Input
                        type="date"
                        size="sm"
                        label="To"
                        labelIcon="calendar-check"
                        value={endDate}
                        onChange={(e) => onEndDateChange(e.target.value)}
                        min={startDate || undefined}
                        wrapperClassName="w-full"
                    />
                </div>
            </div>
        </div>
    );
}
